// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3quHv","topBottomGutter":"Layout_topBottomGutter__1vrST"};